(()=>{
  'use strict';
  const pid=()=>String(new URL(location.href).searchParams.get('draft_product')||window.FultonsPriceTrial?.productId||'');
  function update(section,select){
    const guides=window.FultonsOtherSideboardDrawings?.[pid()];
    const label=select.selectedOptions[0]?.textContent,guide=guides?.[label];if(!guide)return;
    if(!section.classList.contains('sideboard-guided'))section.classList.add('sideboard-guided');
    let figure=section.querySelector('.sideboard-guide');
    if(!figure){
      figure=document.createElement('figure');figure.className='sideboard-guide';
      const image=document.createElement('img');image.loading='lazy';image.decoding='async';
      const caption=document.createElement('figcaption'),link=document.createElement('a');link.target='_blank';link.rel='noopener';link.textContent='Enlarge size drawing';
      figure.append(image,caption,link);select.after(figure);
    }
    const image=figure.querySelector('img'),caption=figure.querySelector('figcaption'),link=figure.querySelector('a');
    if(image.getAttribute('src')!==guide.url)image.src=guide.url;
    if(image.alt!==guide.alt)image.alt=guide.alt;
    const dimensions=label.split(' — ').slice(0,2).filter(p=>!p.includes('/')).join(' · ');
    const text=guide.note||dimensions;if(caption.textContent!==text)caption.textContent=text;
    if(link.getAttribute('href')!==guide.url)link.href=guide.url;
    if(!select.dataset.sideboardGuide){select.dataset.sideboardGuide='true';select.addEventListener('change',()=>update(section,select));}
  }
  function porada(){
    const ids=['15888175530367','15888176087423','15888176644479','15888177299839','15888178315647','15888178971007','15888179757439'];
    if(!ids.includes(pid()))return;
    const norm=s=>s.toLowerCase().replace(/[^a-z0-9]/g,'');
    const drawings=[...document.querySelectorAll('.porada-options__drawing-grid a')];
    for(const article of document.querySelectorAll('.porada-options__model')){
      if(article.querySelector('.sideboard-guide'))continue;
      const model=article.querySelector('h3')?.textContent||'';
      const matches=drawings.filter(a=>{const label=a.querySelector('span')?.textContent||'';return norm(label)===norm(model)||(model==='Atlante 3'&&label==='Atlante 3 1');});
      if(matches.length!==1)continue;
      const source=matches[0],figure=document.createElement('figure');figure.className='sideboard-guide';
      const image=source.querySelector('img')?.cloneNode(true);if(!image)continue;
      const caption=document.createElement('figcaption');caption.textContent=model+' · Supplier size drawing';
      const link=document.createElement('a');link.href=source.href;link.target='_blank';link.rel='noopener';link.textContent='Enlarge size drawing';
      figure.append(image,caption,link);const controls=article.querySelector('.porada-choice__options');(controls||article.querySelector('h3')).after(figure);
    }
  }
  function scan(){
    if(window.FultonsOtherSideboardDrawings?.[pid()])for(const section of document.querySelectorAll('.fcc,.other-exact')){const select=section.querySelector('#FultonsCattelanOption,#FultonsOtherExactChoice');if(select)update(section,select);}
    porada();
  }
  let queued=false;const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;scan();});};
  function start(){scan();const main=document.querySelector('#MainContent');if(main)new MutationObserver(schedule).observe(main,{childList:true,subtree:true});}
  document.addEventListener('fultons:catalogue-updated',schedule);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
